import React, { useState } from "react";
import { Link } from "react-router-dom";
import ExternalCompCategories from "./ExternalCompCategories";
import ExternalSports from "./ExternalSports";
import ExternalLevel from "./ExternalLevel";
import ExternalCompGender from "./ExternalCompGender";
import ExtCompFormats from "./ExtCompFormats";
import ExternalCompClasses from "./ExternalCompClasses";
import ExternalCompCountries from "./ExternalCompCountries";
import ExternalResultFormat from "./ExternalResultFormat";
import ExtCompAthltEntry from "./ExtCompAthltEntry";
import ExternalCompAttempts from "./ExternalCompAttempts";
import ExternalCompSinclairConstants from "./ExternalCompSinclairConstants";

const ExternalCompSettingsTabs = () => {

    const [activeTab, setActiveTab] = useState("Category");

    const tabData = [
        {
            icon: <i className="fas fa-tags" />,
            name: "Category",
            content: <ExternalCompCategories />
        },
        {
            icon: <i className="fas fa-th-large" />,
            name: "Format",
            content: <ExtCompFormats />
        },
        {
            icon: <i className="fas fa-users" />,
            name: "Classes",
            content: <ExternalCompClasses />
        },
        {
            icon: <i className="fas fa-bullseye" />,
            name: "Sport",
            content: <ExternalSports />
        },
        {
            icon: <i className="fas fa-arrow-trend-up" />,
            name: "Levels",
            content: <ExternalLevel />
        },
        {
            icon: <i className="fas fa-mars-and-venus" />,
            name: "Gender",
            content: <ExternalCompGender />
        },
        // {
        //     icon: <i className="fas fa-flag-checkered" />,
        //     name: "Geography",
        //     content: <ExternalCompCountries />
        // },
        {
            icon: <i className="fas fa-list-check" />,
            name: "Sinclair Constants",
            content: <ExternalCompSinclairConstants />
        },
        {
            icon: <i className="fas fa-list-check" />,
            name: "Result Format",
            content: <ExternalResultFormat />
        },
        // {
        //     icon: <i className="fas fa-list-check" />,
        //     name: "Athlete Attempts",
        //     content: <ExternalCompAttempts />
        // },
        // {
        //     icon: <i className="fas fa-running" />,
        //     name: "Athlete Entry",
        //     content: <ExtCompAthltEntry />
        // },
    ]
    return (
        <>
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="sortby-section">
                    <div className="sorting-info">
                        <div className="row">
                            <div className="col-lg-3">
                                <ul className="list-group">
                                    {tabData.map((tab, i) => (
                                        <li key={i}
                                            className={`list-group-item ${activeTab === tab.name ? "active" : ""
                                                }`}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setActiveTab(tab.name)}
                                        >
                                            {tab.name.replaceAll("_", " ").toUpperCase()}
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div className="col-lg-9">
                                {tabData
                                    .filter(tab => tab.name === activeTab)
                                    .map((tab, i) => (
                                        <div key={i}>{tab.content}</div>
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ExternalCompSettingsTabs;